import {
  type ErrorPageProps,
  executeInitialPropsGuards,
} from '../helper/executeInitialPropsGuards';
import { generateErrorPageGuards } from './onboarding/generateErrorPageGuards';
import { ERROR_PAGE_DEFAULT_STATE } from './onboarding/state';

import type { NextPageContext } from 'next';

/**
 * Onboarding _error.tsx의 getInitialProps 래퍼
 *
 * 타입 호환성:
 * - `executeInitialPropsGuards`는 `guards: Guard<BaseState>`, `state: BaseState`를 요구
 * - `generateErrorPageGuards()`는 명시적 반환 타입 `Guard<BaseState>`를 가짐 → guards 호환 ✅
 * - `ERROR_PAGE_DEFAULT_STATE`는 `ServiceAppState`이지만, `ServiceAppState extends BaseState`이므로
 *   구조적 서브타이핑에 의해 `BaseState` 위치에 전달 가능 → state 호환 ✅
 * - 런타임에는 ServiceAppState 전체 필드(token, userId 등)를 포함하므로,
 *   내부 가드(`determineLanguageGuard`)가 정상 접근 가능
 */
export const getInitialPropsOnboardingWrapper = () => {
  const guards = generateErrorPageGuards();

  return async (context: NextPageContext): Promise<ErrorPageProps> => {
    return executeInitialPropsGuards({
      context,
      guards,
      state: ERROR_PAGE_DEFAULT_STATE,
    });
  };
};
